import { apiCall } from './gqlClient';

const GETFEATURES_QUERY = `
  query getFeatures {
    getFeatures
    {
      key
			name
			category
			kind
			unit
			status
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const getFeaturesApiCall = async (fragments = null) => apiCall({ query: GETFEATURES_QUERY, variables: {}, fragments });

const GETPLANFEATURES_QUERY = `
  query getPlanFeatures {
    getPlanFeatures
    {
      planId
			featureKey
			value
			updatedAt
      ...fragments
    }
  }`;

export const getPlanFeaturesApiCall = async (fragments = null) => apiCall({ query: GETPLANFEATURES_QUERY, variables: {}, fragments });

const GETPROVIDERFEATUREOVERRIDES_QUERY = `
  query getProviderFeatureOverrides($providerId: Int!) {
    getProviderFeatureOverrides(providerId: $providerId)
    {
      providerId
			featureKey
			reason
			expiresAt
			createdBy
			updatedAt
      ...fragments
    }
  }`;

export const getProviderFeatureOverridesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPROVIDERFEATUREOVERRIDES_QUERY, variables: {providerId}, fragments });

const UPSERTFEATURE_QUERY = `
  mutation upsertFeature($request: FeatureInput!) {
    upsertFeature(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const upsertFeatureApiCall = async ({request}, fragments = null) => apiCall({ query: UPSERTFEATURE_QUERY, variables: {request}, fragments });

const DELETEFEATURE_QUERY = `
  mutation deleteFeature($key: String!) {
    deleteFeature(key: $key)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deleteFeatureApiCall = async ({key}, fragments = null) => apiCall({ query: DELETEFEATURE_QUERY, variables: {key}, fragments });

const SETPLANFEATURE_QUERY = `
  mutation setPlanFeature($planId: Int!, $featureKey: String!, $value: JSON!) {
    setPlanFeature(planId: $planId, featureKey: $featureKey, value: $value)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const setPlanFeatureApiCall = async ({planId, featureKey, value}, fragments = null) => apiCall({ query: SETPLANFEATURE_QUERY, variables: {planId, featureKey, value}, fragments });

const CLEARPLANFEATURE_QUERY = `
  mutation clearPlanFeature($planId: Int!, $featureKey: String!) {
    clearPlanFeature(planId: $planId, featureKey: $featureKey)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const clearPlanFeatureApiCall = async ({planId, featureKey}, fragments = null) => apiCall({ query: CLEARPLANFEATURE_QUERY, variables: {planId, featureKey}, fragments });

const SETPROVIDERFEATUREOVERRIDE_QUERY = `
  mutation setProviderFeatureOverride($providerId: Int!, $featureKey: String!, $value: JSON!, $reason: String, $expiresAt: DateTime) {
    setProviderFeatureOverride(providerId: $providerId, featureKey: $featureKey, value: $value, reason: $reason, expiresAt: $expiresAt)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const setProviderFeatureOverrideApiCall = async ({providerId, featureKey, value, reason, expiresAt}, fragments = null) => apiCall({ query: SETPROVIDERFEATUREOVERRIDE_QUERY, variables: {providerId, featureKey, value, reason, expiresAt}, fragments });

const CLEARPROVIDERFEATUREOVERRIDE_QUERY = `
  mutation clearProviderFeatureOverride($providerId: Int!, $featureKey: String!) {
    clearProviderFeatureOverride(providerId: $providerId, featureKey: $featureKey)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const clearProviderFeatureOverrideApiCall = async ({providerId, featureKey}, fragments = null) => apiCall({ query: CLEARPROVIDERFEATUREOVERRIDE_QUERY, variables: {providerId, featureKey}, fragments });
